import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";

// Import all page components
import Landing from "./components/pages/Landing";
import ResetPassword from "./components/pages/ResetPassword";
import SelectPlan from "./components/pages/SelectPlan";
import VerifyEmail from "./components/pages/VerifyEmail";
import Dashboard from "./components/pages/Dashboard";
import SurveyBuilder from "./components/pages/SurveyBuilder";
import TakeSurvey from "./components/pages/TakeSurvey";
import Analytics from "./components/pages/Analytics";
import ManageSubscription from "./components/pages/ManageSubscription";
import AdminDashboard from "./components/pages/AdminDashboard";

// Import common component styles
import "./components/common/UpgradeHotspot.css";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/select-plan" element={<SelectPlan />} />
        <Route path="/verify-email/:token" element={<VerifyEmail />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/builder" element={<SurveyBuilder />} />
        <Route path="/survey/:surveyId" element={<TakeSurvey />} />
        <Route path="/analytics/:surveyId" element={<Analytics />} />
        <Route path="/manage-subscription" element={<ManageSubscription />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
